export default "__VITE_ASSET__4ec2a998__"